document.documentElement.classList.add('mt-js');

// Fecha de entrega estimada (snippet cs-delivery): suma días hábiles (lun–vie) a hoy, en la hora local
// del cliente. csDelivery.range(min, max, fecha, corto) sirve para probar cualquier día de la semana.
var csDelivery = window.csDelivery || (window.csDelivery = (function () {
  var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addBiz(d, n) {
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    var c = 0;
    while (c < n) {
      x.setDate(x.getDate() + 1);
      var w = x.getDay();
      if (w !== 0 && w !== 6) c++;
    }
    return x;
  }
  function label(a, b, corto) {
    var A = M[a.getMonth()] + ' ' + a.getDate();
    if (!corto) return A + ' – ' + M[b.getMonth()] + ' ' + b.getDate();
    return a.getMonth() === b.getMonth() ? A + '–' + b.getDate() : A + '–' + M[b.getMonth()] + ' ' + b.getDate();
  }
  function range(min, max, hoy, corto) {
    hoy = hoy || new Date();
    return label(addBiz(hoy, min), addBiz(hoy, Math.max(min, max)), corto);
  }
  function fill(root) {
    (root || document).querySelectorAll('[data-cs-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      if (isNaN(min) || isNaN(max)) return;
      var pre = el.getAttribute('data-pre');
      var txt = (pre ? pre + ' ' : '') + range(min, max, null, el.getAttribute('data-fmt') === 'corto');
      if (el.textContent !== txt) el.textContent = txt; // sin cambio = sin mutación (el observer del carrito no entra en bucle)
    });
    // Línea de entrega (snippet cs-timeline): fecha de hoy del cliente
    (root || document).querySelectorAll('[data-cs-today]').forEach(function (el) {
      var h = new Date(), t = M[h.getMonth()] + ' ' + h.getDate();
      if (el.textContent !== t) el.textContent = t;
    });
  }
  return { addBiz: addBiz, range: range, fill: fill };
})());


// Oferta de lanzamiento (snippet cs-offer): visible solo hasta el final del día de data-end (fecha del navegador).
var csOffer = function () {
  var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  document.querySelectorAll('[data-cs-offer]').forEach(function (el) {
    var m = (el.getAttribute('data-end') || '').match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (!m) { el.remove(); return; }
    var end = new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59);
    if (isNaN(end) || new Date() > end) { el.remove(); return; }
    el.querySelectorAll('[data-cs-offer-date]').forEach(function (d) { d.textContent = M[end.getMonth()] + ' ' + end.getDate(); });
    el.hidden = false;
  });
};

// Pago rápido diferido (sección mt-producto): monta el botón exprés de Shopify (PayPal) tras la carga de la página.
// Si a los 6 s no apareció ningún botón (ningún método exprés activo), se quita el hueco reservado.
var csQuickpay = function () {
  document.querySelectorAll('[data-cs-quickpay]').forEach(function (box) {
    var tpl = box.querySelector('template');
    if (!tpl || box.dataset.done) return;
    box.dataset.done = '1';
    box.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
    setTimeout(function () {
      var h = box.getBoundingClientRect().height;
      box.classList.remove('is-pending');
      if (!box.querySelector('shopify-accelerated-checkout, .shopify-payment-button__button, iframe') && h < 10) box.remove();
    }, 6000);
  });
};
if (document.readyState === 'complete') setTimeout(csQuickpay, 1200); else window.addEventListener('load', function () { setTimeout(csQuickpay, 1200); });

// 11-10 · Ronda 2 de movimiento. Las cifras de la ficha («95,000Pa», «40 min», «1.2 lb») cuentan desde 0
// con el mismo initCountUp de la portada; «4-in-1» y textos sin número se quedan igual.
var csPrepCount = function () {
  document.querySelectorAll('.cs-highlights b:not([data-mt-countup])').forEach(function (b) {
    var m = b.textContent.trim().match(/^(\d[\d,]*(?:\.(\d+))?)(\s*[^\d\s-][^]*)?$/);
    if (!m) return;
    b.setAttribute('data-mt-countup', m[1].replace(/,/g, ''));
    b.setAttribute('data-mt-suffix', m[3] || '');
    b.setAttribute('data-mt-decimals', m[2] ? m[2].length : 0);
  });
};
// Marca con .cs-in los bloques que entran en pantalla (iconos que saltan, columna de la tabla, etc.).
// El contenido es visible siempre; la clase solo dispara la animación una vez.
var csInView = function () {
  var els = document.querySelectorAll('.cs-specband, .mt-trust-badges, .mt-comp-scroll, .cs-promise__card, .cs-tl, [data-cs-inview]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('cs-in'); }); return; }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('cs-in'); obs.unobserve(en.target); } });
  }, { threshold: 0.25 });
  els.forEach(function (el) { obs.observe(el); });
};

// Este archivo se incluye una vez por cada sección mt-*; el guard evita que
// los init se ejecuten (y enganchen sus eventos) varias veces. Sin él, un
// clic en "Add to cart" añadía el producto tantas veces como secciones había.
if (!window.__mtBooted) {
  window.__mtBooted = true;
  var mtBoot = function () {
    initReveal();
    csPrepCount();
    initCountUp();
    csInView();
    initTilt();
    initProducto();
    initBarraMovil();
    initComparador();
    initScrollReviews();
    initZoom();
    csDelivery.fill();
    csOffer();
    // Botón de la sección «CS – Promesa final»: usa el botón principal (misma variante, abre el carrito)
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-cs-promise-atc]');
      if (!b) return;
      var main = document.querySelector('[data-mt-boton-comprar]');
      if (main && !main.disabled) main.click();
      else if (main) main.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    // 11-10 · El icono del carrito salta cuando cambia el número (Dawn re-renderiza #cart-icon-bubble al añadir)
    var bub = document.getElementById('cart-icon-bubble');
    if (bub && 'MutationObserver' in window) {
      var last = (bub.querySelector('.cart-count-bubble') || {}).textContent || '';
      new MutationObserver(function () {
        var now = (bub.querySelector('.cart-count-bubble') || {}).textContent || '';
        if (now === last) return; last = now;
        bub.classList.remove('cs-bump'); void bub.offsetWidth; bub.classList.add('cs-bump');
      }).observe(bub, { childList: true, subtree: true, characterData: true });
    }
    // El carrito de Dawn se re-renderiza al cambiar cantidades: vuelve a poner la fecha
    var cd = document.querySelector('cart-drawer');
    if (cd && 'MutationObserver' in window) new MutationObserver(function () { csDelivery.fill(cd); }).observe(cd, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mtBoot);
  else mtBoot();
}

function initZoom() {
  var trigger = document.querySelector('[data-mt-zoom]');
  if (!trigger) return;

  // Colección de imágenes: miniaturas (alta res) o la principal
  function images() {
    var thumbs = document.querySelectorAll('[data-mt-miniatura]');
    if (thumbs.length) return Array.prototype.map.call(thumbs, function (t) { return t.getAttribute('data-mt-src'); });
    return [trigger.getAttribute('src')];
  }
  var idx = 0;

  var modal = document.createElement('div');
  modal.className = 'mt-zoom';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.hidden = true;
  modal.innerHTML =
    '<button class="mt-zoom-close" aria-label="Close">×</button>' +
    '<button class="mt-zoom-nav mt-zoom-prev" aria-label="Previous">‹</button>' +
    '<img class="mt-zoom-img" alt="">' +
    '<button class="mt-zoom-nav mt-zoom-next" aria-label="Next">›</button>';
  document.body.appendChild(modal);

  var img = modal.querySelector('.mt-zoom-img');
  function show(i) {
    var list = images();
    idx = (i + list.length) % list.length;
    img.src = list[idx];
    modal.querySelectorAll('.mt-zoom-nav').forEach(function (n) { n.style.display = list.length > 1 ? '' : 'none'; });
  }
  function open() {
    // sincroniza con la miniatura activa si la hay
    var active = document.querySelector('[data-mt-miniatura][data-active]');
    var list = images();
    var start = 0;
    if (trigger.getAttribute('src')) { var s = trigger.getAttribute('src'); var f = list.indexOf(s); if (f > -1) start = f; }
    show(start);
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function close() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 250);
  }

  trigger.addEventListener('click', open);
  modal.querySelector('.mt-zoom-close').addEventListener('click', close);
  modal.querySelector('.mt-zoom-prev').addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
  modal.querySelector('.mt-zoom-next').addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  document.addEventListener('keydown', function (e) {
    if (modal.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(idx - 1);
    else if (e.key === 'ArrowRight') show(idx + 1);
  });
}

function initScrollReviews() {
  var links = document.querySelectorAll('[data-mt-scroll-reviews]');
  if (!links.length) return;
  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector('#mt-reviews');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}

function initComparador() {
  var wraps = document.querySelectorAll('[data-mt-comparador]');
  if (!wraps.length) return;
  wraps.forEach(function (wrap) {
    var antes = wrap.querySelector('[data-mt-comp-antes]');
    var asa = wrap.querySelector('[data-mt-comp-asa]');
    var img = wrap.querySelector('[data-mt-comp-antes-img]');
    if (!antes || !asa) return;
    var arrastrando = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var x = clientX - rect.left;
      var pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
      antes.style.width = pct + '%';
      asa.style.left = pct + '%';
      if (img) img.style.width = rect.width + 'px';
    }
    function iniciar() { arrastrando = true; }
    function parar() { arrastrando = false; }
    function mover(e) {
      if (!arrastrando) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(clientX);
    }

    wrap.addEventListener('mousedown', function (e) { iniciar(); setPos(e.clientX); });
    window.addEventListener('mouseup', parar);
    window.addEventListener('mousemove', mover);
    wrap.addEventListener('touchstart', function (e) { iniciar(); setPos(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchend', parar);
    wrap.addEventListener('touchmove', mover, { passive: true });

    window.addEventListener('resize', function () {
      var rect = wrap.getBoundingClientRect();
      if (img) img.style.width = rect.width + 'px';
    });
    var rect0 = wrap.getBoundingClientRect();
    if (img) img.style.width = rect0.width + 'px';

    // 11-10 · Demo automática la primera vez que se ve: el divisor va a la izquierda, a la derecha y vuelve al centro
    // (enseña que se puede arrastrar). Si el cliente lo toca antes, no hace nada.
    var tocado = false;
    wrap.addEventListener('mousedown', function () { tocado = true; });
    wrap.addEventListener('touchstart', function () { tocado = true; }, { passive: true });
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var demo = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        demo.disconnect();
        var pts = [[0, 50], [700, 18], [1600, 82], [2300, 50]], t0 = null;
        function frame(ts) {
          if (tocado) return;
          if (t0 === null) t0 = ts;
          var t = ts - t0, i = 1;
          while (i < pts.length - 1 && t > pts[i][0]) i++;
          var a = pts[i - 1], b = pts[i], p = Math.min(1, Math.max(0, (t - a[0]) / (b[0] - a[0])));
          var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
          var pct = a[1] + (b[1] - a[1]) * e;
          antes.style.width = pct + '%'; asa.style.left = pct + '%';
          if (t < pts[pts.length - 1][0]) requestAnimationFrame(frame);
        }
        setTimeout(function () { requestAnimationFrame(frame); }, 400);
      }, { threshold: 0.6 });
      demo.observe(wrap);
    }
  });
}

function initProducto() {
  var root = document.querySelector('[data-mt-producto]');
  if (!root) return;

  var principal = root.querySelector('[data-mt-imagen-principal]');
  // Cambia la imagen principal. Debe limpiar srcset/sizes: si no, el navegador
  // sigue usando el srcset original e ignora el nuevo .src (por eso la imagen
  // "no cambiaba" al pulsar una miniatura).
  function setPrincipal(url) {
    if (!principal || !url) return;
    principal.removeAttribute('srcset');
    principal.removeAttribute('sizes');
    principal.src = url;
  }
  root.querySelectorAll('[data-mt-miniatura]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setPrincipal(btn.getAttribute('data-mt-src'));
      root.querySelectorAll('[data-mt-miniatura]').forEach(function (b) {
        b.style.borderColor = 'var(--mt-color-borde)';
      });
      btn.style.borderColor = 'var(--mt-color-acento)';
    });
  });

  var datos = root.querySelector('[data-mt-variantes]');
  if (!datos) return;
  var variantes;
  try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
  var selects = root.querySelectorAll('[data-mt-opcion]');
  var inputId = root.querySelector('[data-mt-variant-id]');
  var precio = root.querySelector('[data-mt-precio]');
  var precioAntes = root.querySelector('[data-mt-precio-antes]');
  var badge = root.querySelector('[data-mt-badge-oferta]');
  var ahorroBox = root.querySelector('[data-mt-ahorro]');
  var ahorroMonto = root.querySelector('[data-mt-ahorro-monto]');
  var boton = root.querySelector('[data-mt-boton-comprar]');
  var textoComprar = boton ? boton.textContent.trim() : '';

  // 12-10 · Al elegir variante (pack, color…) la galería desliza hasta SU foto, para que el cliente vea lo que se lleva.
  // Antes se cambiaba [data-mt-imagen-principal], que ya no existe desde la galería deslizable → no pasaba nada.
  // Se compara por nombre de archivo (las URLs llevan ?v= y &width= distintos). También cambia la miniatura de la barra fija.
  var track = root.querySelector('[data-mt-gal-track]');
  var miniBarra = document.querySelector('[data-mt-barra-movil] img');
  function archivo(u) { return String(u || '').split('?')[0].split('/').pop(); }
  function mostrarImagen(url, instantaneo) {
    var f = archivo(url);
    if (miniBarra && f) { miniBarra.removeAttribute('srcset'); miniBarra.src = url.replace(/width=\d+/, 'width=100'); }
    if (!track) { setPrincipal(url); return; }
    var slides = track.querySelectorAll('.mt-gal-slide');
    for (var i = 0; i < slides.length; i++) {
      var im = slides[i].querySelector('img:not(.cs-vslide__poster)');
      if (im && archivo(im.getAttribute('src')) === f) {
        track.scrollTo({ left: i * track.clientWidth, behavior: instantaneo ? 'auto' : 'smooth' });
        slides[i].classList.remove('cs-var-flash'); void slides[i].offsetWidth; slides[i].classList.add('cs-var-flash');
        return;
      }
    }
  }

  function actualizar() {
    var elegidas = [];
    selects.forEach(function (s) { elegidas[parseInt(s.getAttribute('data-mt-opcion-index'), 10)] = s.value; });
    var v = variantes.find(function (x) {
      return x.options.every(function (opt, i) { return opt === elegidas[i]; });
    });
    if (!v) {
      if (boton) { boton.disabled = true; boton.textContent = 'No disponible'; }
      return;
    }
    if (inputId) inputId.value = v.id;
    if (precio) precio.textContent = v.price;
    if (precioAntes) {
      precioAntes.textContent = v.compare_at || '';
      precioAntes.style.display = v.compare_at ? '' : 'none';
    }
    if (badge) badge.style.display = v.compare_at ? '' : 'none';
    if (ahorroBox) {
      if (v.ahorro) {
        if (ahorroMonto) ahorroMonto.textContent = v.ahorro;
        ahorroBox.style.display = '';
      } else {
        ahorroBox.style.display = 'none';
      }
    }
    if (v.imagen) mostrarImagen(v.imagen);
    if (boton) {
      boton.disabled = !v.available;
      boton.textContent = v.available ? textoComprar : (boton.getAttribute('data-mt-texto-agotado') || 'Agotado');
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  // Enlace con ?variant= (p. ej. desde un anuncio o el carrito): abre la galería en la foto de esa variante
  var vq = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
  if (vq) {
    var vIni = variantes.find(function (x) { return String(x.id) === vq; });
    if (vIni && vIni.imagen) window.addEventListener('load', function () { mostrarImagen(vIni.imagen, true); });
  }

  // Swatches de color: sincronizan con su <select> (oculto) y reusan actualizar()
  root.querySelectorAll('[data-mt-swatch]').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var idx = sw.getAttribute('data-mt-opcion-index');
      var val = sw.getAttribute('data-mt-value');
      var sel = root.querySelector('select[data-mt-opcion][data-mt-opcion-index="' + idx + '"]');
      if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      root.querySelectorAll('[data-mt-swatch][data-mt-opcion-index="' + idx + '"]').forEach(function (o) {
        var on = (o === sw);
        o.classList.toggle('is-active', on);
        if (o.hasAttribute('role')) o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var label = root.querySelector('[data-mt-color-label][data-mt-opcion-index="' + idx + '"]');
      if (label) label.textContent = val;
    });
  });

  // AJAX add-to-cart: añade sin recargar, muestra estado y abre el carrito lateral
  if (boton) {
    var form = boton.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = inputId ? inputId.value : null;
        if (id) mtAddToCart(id, 1, boton);
      });
    }
  }
}

function mtOpenDrawer() {
  var d = document.querySelector('cart-drawer');
  if (!d) return;
  if (typeof d.open === 'function') { d.open(); return; }
  d.classList.remove('is-empty');
  d.classList.add('active', 'animate');
  d.setAttribute('open', '');
  document.body.classList.add('overflow-hidden');
}

function mtApplySections(sections) {
  if (!sections) return;
  // Carrito lateral
  if (sections['cart-drawer']) {
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    var current = document.querySelector('#CartDrawer');
    if (fresh && current) { current.innerHTML = fresh.innerHTML; csDelivery.fill(current); }
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) drawerEl.classList.remove('is-empty');
  }
  // refresca la barra de envío + upsell del bundle con el carrito nuevo
  if (window.mtCartRefresh) setTimeout(window.mtCartRefresh, 60);
  // Burbuja del icono del carrito
  if (sections['cart-icon-bubble']) {
    var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var b = document.querySelector('#cart-icon-bubble');
    var freshB = doc2.querySelector('#cart-icon-bubble') || doc2.body.firstElementChild;
    if (b && freshB) b.innerHTML = freshB.innerHTML;
  }
}

function mtAddToCart(id, qty, btn) {
  var original = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.classList.add('mt-btn-loading'); btn.innerHTML = '<span class="mt-spinner" aria-hidden="true"></span>'; }
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty || 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
  }).then(function (res) {
    return res.json().then(function (data) { return { ok: res.ok, data: data }; });
  }).then(function (r) {
    if (btn) btn.classList.remove('mt-btn-loading');
    if (r.ok) {
      mtApplySections(r.data.sections);
      mtOpenDrawer();
      if (btn) {
        btn.textContent = '✓ Added to cart!';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500);
      }
    } else {
      if (btn) { btn.textContent = (r.data && r.data.description) || 'Could not add — try again'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500); }
    }
  }).catch(function () {
    if (btn) { btn.classList.remove('mt-btn-loading'); btn.textContent = 'Could not add — try again'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500); }
  });
}

function initBarraMovil() {
  var barra = document.querySelector('[data-mt-barra-movil]');
  var root = document.querySelector('[data-mt-producto]');
  if (!barra || !root) return;
  var botonPrincipal = root.querySelector('[data-mt-boton-comprar]');
  var botonBarra = barra.querySelector('[data-mt-barra-boton]');
  var precioBarra = barra.querySelector('[data-mt-precio-barra]');
  var precioPrincipal = root.querySelector('[data-mt-precio]');

  if (botonBarra) {
    var inputId = root.querySelector('[data-mt-variant-id]');
    botonBarra.addEventListener('click', function () {
      var id = inputId ? inputId.value : null;
      if (id) mtAddToCart(id, 1, botonBarra);
      else if (botonPrincipal) botonPrincipal.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
  if (precioBarra && precioPrincipal) {
    new MutationObserver(function () {
      precioBarra.textContent = precioPrincipal.textContent;
    }).observe(precioPrincipal, { childList: true, characterData: true, subtree: true });
  }
  if (botonPrincipal && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      barra.classList.toggle('mt-visible-barra', !entries[0].isIntersecting);
      barra.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
      barra.inert = entries[0].isIntersecting; // 11-10: oculta = sin foco de teclado (Lighthouse aria-hidden-focus)
    }, { threshold: 0 }).observe(botonPrincipal);
  }
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function fmtNum(n, d){ return Number(n).toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d }); }

function initCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var target = parseFloat(el.getAttribute('data-mt-countup')) || 0;
      var suffix = el.getAttribute('data-mt-suffix') || '';
      var decimals = parseInt(el.getAttribute('data-mt-decimals') || '0', 10);
      if (prefersReduced) {
        el.textContent = fmtNum(target, decimals) + suffix;
        return;
      }
      var duration = 1600;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = fmtNum(target * eased, decimals) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) {
    var t0 = parseFloat(el.getAttribute('data-mt-countup')) || 0;
    var s0 = el.getAttribute('data-mt-suffix') || '';
    var d0 = parseInt(el.getAttribute('data-mt-decimals') || '0', 10);
    el.textContent = fmtNum(t0, d0) + s0;
    obs.observe(el);
  });
}

function initTilt() {
  return; /* disabled: mousemove transforms caused paint jank on scroll */
  var cards = document.querySelectorAll('[data-mt-tilt]');
  if (!cards.length) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(700px) rotateX(' + (y * -6) + 'deg) rotateY(' + (x * 6) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}
